<template>
  <div class="p-feed">
    <HeaderSearch class="header-search" @focu="handleFocus" />
    <FeedSwiper class="feed-swiper" />

    <Bulletin>
      <div slot="footer">
        <main class="feed-main">
          <div class="category">
            <div v-for="(cate, index) in category" :key="index">
              <RouterLink :to="cate.path">
                <img :src="cate.img" :alt="cate.name" />
                <div class="cate-name">{{ cate.name }}</div>
              </RouterLink>
            </div>
          </div>
        </main>
      </div>
    </Bulletin>

    <FootGuide />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Bulletin from "./components/Bulletin.vue";
import FeedSwiper from "./components/feedSwiper.vue";
import questionImg from "../../images/index/question@2x.png";
import shareImg from "../../images/index/share@2x.png";
import circleImg from "../../images/index/ico_circle@2x.png";
import rankImg from "../../images/index/ico_rank@2x.png";
import expertImg from "../../images/index/experts@2x.png";
import messageImg from "../../images/index/massage@2x.png";
import searchImg from "../../images/index/search@2x.png";
import homepageImg from "../../images/index/homepage@2x.png";
import AnnouncementImg from "../../images/index/announcement@2x.png";
import { getNewsList } from "@/api/feeds";

export default {
  name: "FeedList",
  components: { FeedSwiper, Bulletin },
  data() {
    return {
      category: [],
      notices: []
    };
  },
  computed: {
    ...mapState(["CURRENTUSER"])
  },
  beforeRouteEnter(to, from, next) {
    if (from.path.indexOf("/sigin") > -1) {
      this.$bus.$emit("check-in");
    }
    next();
  },
  created() {
    this.$bus.$emit("check-in");
    this.getList();
    this.category = [
      {
        name: this.$t("group.name"),
        img: circleImg,
        path: "/groups?category=all"
      },
      {
        name: this.$t("expert.found"),
        img: expertImg,
        path: "/search?topic=hot"
      },
      {
        name: this.$t("rank.name"),
        img: rankImg,
        path: "/rank/list?type=question"
      },
      {
        name: this.$t("news.name"),
        img: AnnouncementImg,
        path: "/news"
      },
      {
        name: this.$t("question.qa"),
        img: questionImg,
        path: "/question?type=new"
      },

      { name: this.$t("feed.name"), img: shareImg, path: "/shares" },

      { name: this.$t("message.name"), img: messageImg, path: "/message/list" },

      {
        name: this.$t("profile.home.name"),
        img: homepageImg,
        path: `users/${this.CURRENTUSER.id}/bio`
      }
    ];
    this.$store.dispatch("message/getAllUnreadCount");
  },
  methods: {
    handleFocus() {
      this.$router.push({
        path: "/search_list?type=share"
      });
    },
    getList() {
      getNewsList().then(res => {
        this.notices = res.data;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.p-feed {
  background-color: white;
  min-height: 100vh;
  .cate-name {
    color: @tool-bar-bg;
    font-size: 24px;
  }
  .feed-main {
    margin: 30px;
  }
  .category {
    background-color: #f7f7f7;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    background: rgba(247, 247, 247, 1);
    border-radius: 12px;
    padding: 20px 0 23px;
    > div {
      display: inline-block;
      text-align: center;
      flex: 0 0 25%;
      margin-bottom: 10px;
    }
    img {
      height: 94px;
      display: inline-block;
    }
  }
  .feed-swiper {
    z-index: 999;
  }
  .notice-title {
    font-size: 28px;
    color: #3283a2;
    margin: 30px 0 25px;
  }
  .notice-list {
    padding: 36px 30px 0;
    background: rgba(247, 247, 247, 1);
    border-radius: 12px;
    > div {
      padding: 36px 0;
      border-bottom: 1px dashed #ccc;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        border-bottom: 0 dashed transparent;
      }
    }

    .news-list {
      display: flex;
      justify-content: space-around;
      > div {
        display: inline-block;
      }
      .news-title {
        flex-grow: 1;
        font-size: 28px;
        a {
          color: @tool-bar-bg;
        }
      }
      .dot {
        margin-right: 10px;
      }
    }
  }
  .header-search {
    z-index: 1;
    position: absolute;
    top: 17px;
    width: 100%;
  }
}
</style>
